import React, { useState, useEffect } from 'react';
import { format } from 'date-fns';
import { API_BASE_URL } from '../../config';
import './ExcelAccount.css';

const PartnerAccount = () => {
  const [partners, setPartners] = useState([]);
  const [partnerTotals, setPartnerTotals] = useState([]);
  const [history, setHistory] = useState([]);
  const [totalMd, setTotalMd] = useState(0);
  const [selectedPartner, setSelectedPartner] = useState('');
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');
  const [error, setError] = useState('');

  const fetchData = async (partner = '', from = '', to = '') => {
    setError('');
    try {
      const params = new URLSearchParams();
      if (partner) params.append('partner', partner);
      if (from && to) {
        params.append('date_from', from);
        params.append('date_to', to);
      }
      const query = params.toString();
      const url = `${API_BASE_URL}/partner-account${query ? `?${query}` : ''}`;
      const response = await fetch(url);
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.details || data.error || 'Failed to fetch partner account data');
      }

      setHistory(data.history || []);
      setPartners(data.partners || []);
      setPartnerTotals(data.partner_totals || []);
      setTotalMd(Number(data.total_md || 0));
    } catch (err) {
      console.error('Error fetching partner account data:', err);
      setError(err.message || 'Failed to load partner account data.');
      setHistory([]);
      setPartners([]);
      setPartnerTotals([]);
      setTotalMd(0);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleApplyFilter = () => {
    if (dateFrom && dateTo && new Date(dateFrom) > new Date(dateTo)) {
      alert('From date cannot be greater than To date.');
      return;
    }
    fetchData(selectedPartner, dateFrom, dateTo);
  };

  const handleClearFilter = () => {
    setSelectedPartner('');
    setDateFrom('');
    setDateTo('');
    fetchData();
  };

  const formatDate = (value) => {
    if (!value) return 'N/A';
    try {
      return format(new Date(value), 'dd-MM-yyyy');
    } catch {
      return value;
    }
  };

  return (
    <div className="finance-container">
      <h2>Partner Account (MD Share)</h2>
      <p style={{ textAlign: 'center', color: '#555', marginTop: '-20px', marginBottom: '30px' }}>
        30% share from General Loan, CD Loan, and TBD Loan overdue collections
      </p>

      <div className="totals">
        <h3>Total MD Amount: ₹{totalMd.toFixed(2)}</h3>
      </div>

      {error && (
        <p style={{ textAlign: 'center', color: '#c0392b', marginBottom: '20px' }}>
          {error}
        </p>
      )}

      {partnerTotals.length > 0 && (
        <div className="history-table-container" style={{ marginBottom: '30px' }}>
          <h3>Partner-wise MD Summary</h3>
          <table className="history-table">
            <thead>
              <tr>
                <th>Partner Name</th>
                <th>MD Amount (₹)</th>
              </tr>
            </thead>
            <tbody>
              {partnerTotals.map((row) => (
                <tr key={row.partner_name}>
                  <td>{row.partner_name}</td>
                  <td className="credited">{Number(row.total_md).toFixed(2)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <div className="filter-section" style={{ display: 'flex', flexWrap: 'wrap', gap: '15px', alignItems: 'center', marginBottom: '25px' }}>
        <label>Filter by Partner: </label>
        <select value={selectedPartner} onChange={(e) => setSelectedPartner(e.target.value)}>
          <option value="">All</option>
          {partners.map((partner) => (
            <option key={partner} value={partner}>{partner}</option>
          ))}
        </select>
        <label>From: </label>
        <input type="date" value={dateFrom} onChange={(e) => setDateFrom(e.target.value)} />
        <label>To: </label>
        <input type="date" value={dateTo} onChange={(e) => setDateTo(e.target.value)} />
        <button onClick={handleApplyFilter}>Apply</button>
        <button onClick={handleClearFilter}>Clear</button>
      </div>

      <h3>MD Transaction History</h3>
      <div className="history-table-container">
        {history.length > 0 ? (
          <table className="history-table">
            <thead>
              <tr>
                <th>Loan Type</th>
                <th>Partner Name</th>
                <th>Account No</th>
                <th>Debtor Name</th>
                <th>Total Paid (₹)</th>
                <th>Overdue (70%) (₹)</th>
                <th>MD (30%) (₹)</th>
                <th>Installment Date</th>
                <th>Payment Date</th>
              </tr>
            </thead>
            <tbody>
              {history.map((entry) => (
                <tr key={`${entry.loan_type}-${entry.id}`}>
                  <td>{entry.loan_type}</td>
                  <td>{entry.partner_name}</td>
                  <td>{entry.account_no}</td>
                  <td>{entry.debtor_name}</td>
                  <td>{(Number(entry.overdue_paid) + Number(entry.md || 0)).toFixed(2)}</td>
                  <td>{Number(entry.overdue_paid).toFixed(2)}</td>
                  <td className="credited">{Number(entry.md || 0).toFixed(2)}</td>
                  <td>{formatDate(entry.installment_date)}</td>
                  <td>{entry.payment_date ? formatDate(entry.payment_date) : 'N/A'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p className="no-history">No MD transactions yet.</p>
        )}
      </div>
    </div>
  );
};

export default PartnerAccount;
